import { gql } from '@apollo/client';

export const PLAYER_INFO_FRAGMENT = gql`
  fragment PlayerInfo on players {
    id
    firstName
    lastName
    jersey
    jerseySecondary
    position
    positionSecondary
  }
`;
